import { Injectable } from '@angular/core';
import {
  InstallationGroupDetail,
  InstallationGroupFilterModel,
  InstallationGroupInstallationsResponseModel,
  InstallationGroupMemberDevicesResponseModel,
  InstallationGroupMemberLocationsResponseModel,
  InstallationGroupsResponseModel,
  InstallationGroupWithAccess,
  NewInstallationGroup,
  UpdateInstallationGroup,
} from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InstallationGroupService {
  constructor(private readonly apiService: ApiService) {}

  getInstallationGroups(
    filter: InstallationGroupFilterModel,
  ): Observable<InstallationGroupsResponseModel> {
    return this.apiService.get('/partners/installation-groups/', filter as any);
  }

  getInstallationGroup(groupOid: string): Observable<InstallationGroupDetail> {
    return this.apiService.get(`/partners/installation-groups/${groupOid}`);
  }

  createInstallationGroup(
    partnerOid: string,
    group: NewInstallationGroup,
  ): Observable<InstallationGroupWithAccess> {
    return this.apiService.post(`/partners/${partnerOid}/installation-groups`, group);
  }

  updateInstallationGroup(
    groupOid: string,
    changes: UpdateInstallationGroup,
  ): Observable<InstallationGroupWithAccess> {
    return this.apiService.put(`/partners/installation-groups/${groupOid}`, changes);
  }

  getInstallationGroupDevices(
    groupOid: string,
    limit: number = 10,
    offset: number = 0,
  ): Observable<InstallationGroupMemberDevicesResponseModel> {
    return this.apiService.get(
      `/partners/installation-groups/${groupOid}/devices`,
      { limit, offset } as any,
    );
  }

  getInstallationGroupLocations(
    groupOid: string,
    limit: number = 10,
    offset: number = 0,
  ): Observable<InstallationGroupMemberLocationsResponseModel> {
    return this.apiService.get(
      `/partners/installation-groups/${groupOid}/locations`,
      { limit, offset } as any,
    );
  }

  getInstallationGroupInstallations(
    groupOid: string,
    limit = 10,
    offset = 0,
  ): Observable<InstallationGroupInstallationsResponseModel> {
    return this.apiService.get<InstallationGroupInstallationsResponseModel>(
      `/partners/installation-groups/${groupOid}/installations`,
      { limit, offset },
    );
  }

  addDeviceToGroup(groupOid: string, deviceId: number): Observable<any> {
    return this.apiService.post(`/partners/installation-groups/${groupOid}/devices`, { deviceId });
  }

  addLocationToGroup(groupOid: string, locationId: number): Observable<any> {
    return this.apiService.post(`/partners/installation-groups/${groupOid}/locations`, {
      locationId,
    });
  }

  removeDeviceFromGroup(groupOid: string, deviceId: number): Observable<any> {
    return this.apiService.delete(
      `/partners/installation-groups/${groupOid}/devices/${deviceId}`,
    );
  }

  removeLocationFromGroup(groupOid: string, locationId: number): Observable<any> {
    return this.apiService.delete(
      `/partners/installation-groups/${groupOid}/locations/${locationId}`,
    );
  }
}
